import { useMemo } from 'react';
import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';
import { FAQ_GROUPS } from '@/mocks/faq';
import { SITE_EMAIL, SITE_NAME } from '@/mocks/site';
import HeroSection from '@/pages/home/components/HeroSection';
import KeyMilestones from '@/pages/home/components/KeyMilestones';
import PhaseOverview from '@/pages/home/components/PhaseOverview';
import WeeklyPlan from '@/pages/home/components/WeeklyPlan';
import Highlights from '@/pages/home/components/Highlights';
import Voices from '@/pages/home/components/Voices';
import FaqPreview from '@/pages/home/components/FaqPreview';
import SubscribeForm from '@/pages/home/components/SubscribeForm';

export default function Home() {
  const previewFaq = useMemo(() => FAQ_GROUPS.flatMap((g) => g.items).slice(0, 4), []);

  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE_NAME,
        alternateName: '爆料大赛赛程时间表',
        description: '爆料大赛赛程时间表与活动安排发布页，汇总比赛进度、关键节点与阶段日程。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: SITE_NAME,
        description: '专注发布爆料大赛赛程时间表、活动安排与比赛进度的赛事信息站点。',
        email: SITE_EMAIL,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '爆料大赛 - 赛程时间表与活动安排，比赛进度日程随时查',
        description:
          '爆料大赛赛程怎么走？时间表、活动安排、比赛进度全在这。从海选到决赛，哪天截稿、哪天开投、哪天出结果，按日程盯紧就行。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: previewFaq.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
    [previewFaq],
  );

  usePageMeta({
    title: '爆料大赛 - 赛程时间表与活动安排，比赛进度日程随时查',
    description:
      '爆料大赛赛程怎么走？时间表、活动安排、比赛进度全在这。从海选到决赛，哪天截稿、哪天开投、哪天出结果，按日程盯紧就行，不用再到处问人。',
    keywords: '爆料大赛,爆料大赛赛程,爆料大赛时间表,爆料大赛比赛进度,爆料大赛活动安排,爆料大赛日程',
    path: '/',
    jsonLd,
  });

  return (
    <SiteLayout>
      <HeroSection />
      <KeyMilestones />
      <PhaseOverview />
      <WeeklyPlan />
      <Highlights />
      <Voices />
      <FaqPreview />
      <SubscribeForm />
    </SiteLayout>
  );
}